export const environment = {
  url: 'https://store.dev.keys7.com',
  SHOP_API: 'shop.dev.keys7.com/shop-api',
  DISCORD_CLIENT_ID: '1343878477232996392',
  GOOGLE_CLIENT_ID:
    '947589860525-t9jiieuop3ui6f2ga99grlrqrjetp7qd.apps.googleusercontent.com',
  FACEBOOK_APP_ID: '1014575249904782',
  MICROSOFT_CLIENT_ID: '4c60d9af-b9e2-4ce0-a43f-a6110d50145b',
  APPLE_CLIENT_ID: 'com.keys7.login.client',
  APPLE_CALLBACK_URL: 'https://shop.dev.keys7.com',
  PROTOCOL: 'https://',
  VENDURE_URL: 'shop.dev.keys7.com',
  VENDURE_PORT: 443,
}
